import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.dev";
import { BaseService } from "../../@core/services/base.service";
import { IAdobeSignSetting } from "../../@core/models/model";

@Injectable({ providedIn: 'root', })
export class AdobeSignService extends BaseService {
    apiUrl = environment.apiUrl + '/adobe-sign'
    adobeApiUrl = environment.apiUrl + '/adobe-sign-settings'

    constructor(protected override http: HttpClient) {
        super(http);
    }

    authAdobeSignature() {
        return this.get<any>(this.apiUrl + '/authenticate')
    }

    checkForAccessToken() {
        return this.get<boolean>(this.apiUrl + '/check-access-token')
    }

    setAccessToken(code: string, redirect_uri: string) {
        return this.post<IAdobeSignSetting>(this.apiUrl + '/token', { code, redirect_uri })
    }

    revokeConsent() {
        return this.put(this.apiUrl + '/revoke-consent', {})
    }

    getSettings() {
        return this.get<{
            clientId: string
            clientSecret: string
            consent?: boolean
            updatedAt: string
        }>(this.adobeApiUrl)
    }

    saveSettings(data: {
        clientId: string
        clientSecret: string
        consent?: boolean
    }) {
        return this.post<boolean>(this.adobeApiUrl + '/save', data)
    }

}